import React from 'react';
import { QrCode as QrCodeIcon } from 'lucide-react';

/**
 * QR Kod bileşeni
 * 
 * @param {Object} props - Bileşen özellikleri
 * @param {string} props.data - QR kodunda kodlanacak veri
 * @param {string} props.size - QR kod boyutu ('small', 'medium', 'large')
 * @param {string} props.name - QR kod adı/etiketi
 * @param {string} props.id - QR kod ID'si
 * @param {boolean} props.showBorder - Kenarlık gösterilsin mi?
 */
const QRCode = ({ 
  data = 'https://idapps.io/id/12345',
  size = 'medium',
  name = 'Dövme',
  id = '#ID12345',
  showBorder = true
}) => {
  // QR kod boyutlarını hesapla
  const getContainerSize = () => {
    switch (size) {
      case 'small':
        return 'w-32 h-32';
      case 'large':
        return 'w-80 h-80';
      case 'medium':
      default:
        return 'w-64 h-64';
    }
  };

  // QR kod simge boyutunu hesapla
  const getIconSize = () => {
    switch (size) {
      case 'small':
        return 100;
      case 'large':
        return 250;
      case 'medium':
      default:
        return 200;
    }
  };

  const containerSize = getContainerSize();
  const iconSize = getIconSize();

  // Gerçek bir QR kod kütüphanesi olmadığından, şimdilik bir QR kod simgesi gösteriyoruz
  // Gerçek uygulamada qrcode.react veya benzeri bir kütüphane kullanılmalıdır
  return (
    <div className="flex flex-col items-center space-y-4">
      <div className={`${containerSize} bg-white ${showBorder ? 'border-2 border-indigo-200' : ''} rounded-lg flex items-center justify-center`}>
        <QrCodeIcon size={iconSize} />
      </div>
      {(name || id) && (
        <div className="text-center">
          {name && <p className="text-gray-600">{name}</p>}
          {id && <p className="text-sm text-gray-500">{id}</p>}
        </div>
      )}
    </div>
  );
};

export default QRCode;
